// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "36e248daba3f5be28905b2cd88c13639" + ".js";
};